import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useState } from "react";

import "../ActiveOrder/activeorder.css";
import { useEffect } from "react";

import SwipeToVend from "../SwipVend/Swipvend";
import CircularTimer from "./timer";
import CancelSuccessModal from "./CancelSuccessModal";
import CancelErrorModal from "./canelErrorModel";
import CancelOrderModal from "./CancelOrderModal";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusyMachineModal from "../VendOrder/BusyMachineModal";
import WaitingLoder from "../../Loader/component";
import logger from "../../Utils/logger";

const HEADER_HEIGHT = 56;

// All sizes use px / % / clamp() so the layout scales from small phones
// (320px) up to tablets and desktop without vw values blowing up.
const modalStyles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    overflowX: "hidden",
    boxSizing: "border-box",
    paddingTop: HEADER_HEIGHT + 16,
    paddingBottom: 24,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  section: {
    padding: "0 clamp(12px, 4vw, 24px)",
  },
  topRow: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "12px",
    paddingTop: "clamp(12px, 4vw, 20px)",
  },
  companyName: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    paddingBottom: "5px",
    fontWeight: 500,
    lineHeight: "16.41px",
    letterSpacing: "0.02em",
    textAlign: "start",
    color: "rgba(113, 129, 152, 1)",
    wordBreak: "break-word",
  },
  address: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "14.06px",
    textAlign: "start",
    color: "rgba(113, 129, 152, 0.7)",
    wordBreak: "break-word",
  },
  pickupCodeSection: {
    backgroundColor: "rgba(210, 238, 229, 0.1)",
    marginTop: "clamp(12px, 5vw, 24px)",
    padding: "clamp(12px, 4vw, 20px)",
  },
  textPickupCode: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "clamp(16px, 4.5vw, 18px)",
    fontWeight: 600,
    lineHeight: "1.2",
    textAlign: "left",
    color: "rgba(56, 79, 111, 1)",
  },
  textPickupCodeSub: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.2px",
    textAlign: "left",
    color: "rgba(100, 116, 139, 1)",
    margin: "8px 0 16px",
  },
  codeRow: {
    display: "flex",
    justifyContent: "center",
    gap: "clamp(8px, 3vw, 16px)",
  },
  codeBox: {
    flex: "1 1 0",
    maxWidth: "72px",
    aspectRatio: "1 / 1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid rgba(0, 177, 119, 0.5)",
    borderRadius: "8px",
    boxSizing: "border-box",
  },
  codeText: {
    fontSize: "clamp(20px, 6vw, 28px)",
    fontWeight: 700,
    color: "rgba(0, 177, 119, 0.5)",
    margin: 0,
  },
  orderIdRow: {
    padding: "clamp(12px, 4vw, 20px) clamp(12px, 4vw, 24px) 0",
  },
  lineItemsWrap: {
    padding: "0 clamp(12px, 4vw, 24px)",
  },
  lineItem: {
    border: "1px solid rgba(56, 79, 111, 0.08)",
    borderRadius: "10px",
    marginTop: "12px",
    padding: "clamp(10px, 3.5vw, 16px)",
    display: "flex",
    alignItems: "center",
    gap: "clamp(12px, 4vw, 20px)",
  },
  lineItemImg: {
    width: "clamp(52px, 16vw, 72px)",
    height: "clamp(52px, 16vw, 72px)",
    objectFit: "contain",
    flexShrink: 0,
  },
  lineItemBody: {
    flex: 1,
    minWidth: 0,
  },
  lineItemMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    marginTop: "clamp(10px, 4vw, 22px)",
  },
  iteam: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "clamp(14px, 4vw, 16px)",
    fontWeight: 500,
    lineHeight: "18.75px",
    color: "rgba(113, 129, 152, 1)",
  },
  price: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "clamp(14px, 4vw, 16px)",
    fontWeight: 500,
    lineHeight: "18.75px",
    color: "rgba(0, 177, 119, 1)",
    whiteSpace: "nowrap",
  },
  totalCard: {
    border: "1px solid rgba(56, 79, 111, 0.08)",
    padding: "clamp(12px, 4vw, 20px)",
    borderRadius: "10px",
    marginTop: "12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    color: "rgba(56, 79, 111, 1)",
  },
  actions: {
    display: "flex",
    gap: "12px",
    padding: "clamp(12px, 4vw, 24px)",
  },
  helpBtn: {
    flex: 1,
    minHeight: "48px",
    border: "1px solid rgba(113, 129, 152, 0.38)",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "8px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
};

function ActiveOrder(props) {
  const { setBusyPopupFlag, busyPopupFlag, machineError, fetchCode } = props;

  const navigate = useNavigate();
  const { orderId, status } = useParams();
  logger.log("cancleErrorflag", props?.cancleErrorflag);

  const handleBack = () => {
    navigate(`/pickupOptions/${orderId}`);
  };

  const MyHeader = () => {
    return (
      <Box
        display="flex"
        alignItems="center"
        px={1}
        sx={{
          background: "#fae14b",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: HEADER_HEIGHT,
          zIndex: 999,
          boxSizing: "border-box",
        }}
      >
        <IconButton onClick={handleBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 500, ml: 1, fontSize: { xs: "1.1rem", sm: "1.25rem" } }}>
          Active Order
        </Typography>
      </Box>
    );
  };

  const [diffInMs, setDiffInMs] = useState();

  function Truncatedproname({ text, limit, fontSize }) {
    const shown = text && text.length > limit ? text.substring(0, limit) : text;
    return (
      <span style={{ fontSize: fontSize ? fontSize : "14px", color: "#384F6F" }}>
        {shown}
      </span>
    );
  }

  function TruncatedVmadd({ text, limit }) {
    const shown = text && text.length > limit ? text.substring(0, limit) : text;
    return <span style={{ color: "rgba(113, 129, 152, 1)" }}>{shown}</span>;
  }

  const updatetime = () => {
    let alltimer = [];
    props &&
      props.epochtime &&
      props.epochtime[0] &&
      props.epochtime.map((el, index) => {
        const time = props.epochtime[index] - Date.now();
        const currentMinutes = Math.floor(time / 60000);
        alltimer.push(currentMinutes);
        setDiffInMs(alltimer);
      });
  };

  const helpFun = (e, order_id) => {
    logger.log("order_id", order_id);
    navigate(`/ordersearch?id=${order_id}`);
  };

  useEffect(() => {
    updatetime();
  }, [props.epochtime, diffInMs]);

  useEffect(() => {
    // Recalculate every 1 minute
    const intervalId = setInterval(updatetime, 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const CreatedTime = (props) => {
    const date = new Date(props.time);
    // Convert to Indian time string
    const indianTime = date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
    return <>{indianTime}</>;
  };

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");

  const isDisabled =
    props?.activeOrder?.status === "completed" ||
    props?.activeOrder?.status === "cancelled";

  const dcCode = props?.activeOrder?.dcCode || "";

  return (
    <>
      {props?.loader && <WaitingLoder />}
      {busyPopupFlag && (
        <BusyMachineModal setBusyPopupFlag={setBusyPopupFlag} machineError={machineError} />
      )}
      <MyHeader />

      {/* Cancel Order Modal */}
      {props?.cancleflag && (
        <CancelOrderModal setCancleflag={props?.setCancleflag} CancleOrder={props?.CancleOrder} />
      )}

      {/* Cancel Error Modal */}
      {props?.cancleErrorflag && (
        <CancelErrorModal
          props={props?.cancleErrorflag}
          setCancleErrorflag={props?.setCancleErrorflag}
          cancleErrorMsg={props?.cancleErrorMsg}
          cancleErrorflag={props?.cancleErrorflag}
          activeOrder={props?.activeOrder}
        />
      )}

      {/* Cancel Success Modal */}
      {props?.cancleSuccessflag && (
        <CancelSuccessModal
          setCancleSuccessflag={props.setCancleSuccessflag}
          cancleSuccessMsg={props.cancleSuccessMsg}
        />
      )}

      {/* Active Orders */}
      {UserJWTAuth ? (
        <div
          style={{
            ...modalStyles.page,
            // leave room for the fixed Swipe To Vend bar so it never covers the buttons
            paddingBottom: status == "true" ? 110 : 24,
          }}
        >
          <div style={modalStyles.modal}>
            {/* Machine + timer */}
            <div style={modalStyles.section}>
              <div style={modalStyles.topRow}>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <h2 style={modalStyles.companyName}>
                    <TruncatedVmadd text={props?.activeOrder?.vendingMachineAddress} limit={40} />
                  </h2>
                  <p style={modalStyles.address}>
                    <TruncatedVmadd text={props?.activeOrder?.vendingMachineAddress} limit={40} />
                  </p>
                </div>
                <div style={{ flexShrink: 0 }}>
                  <CircularTimer
                    createdAt={props?.activeOrder?.createdAt}
                    pickupTime={props?.activeOrder?.pickupTime}
                  />
                </div>
              </div>
            </div>

            {/* Pickup code */}
            {status == "false" && (
              <div style={modalStyles.pickupCodeSection}>
                <h1 style={modalStyles.textPickupCode}>To pick your order</h1>
                <p style={modalStyles.textPickupCodeSub}>
                  Enter the pickup code on the vending machine
                </p>
                <div style={modalStyles.codeRow}>
                  {[0, 1, 2, 3].map((i) => (
                    <div key={i} style={modalStyles.codeBox}>
                      <p style={modalStyles.codeText}>{dcCode[i]}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Order ID */}
            <div style={modalStyles.orderIdRow}>
              <h1 style={{ color: "rgba(113, 129, 152, 1)", wordBreak: "break-all" }}>
                Order ID:#{" "}
                <span style={{ color: "rgba(56, 79, 111, 1)" }}>{props?.activeOrder?.orderId}</span>
              </h1>
              <p style={{ color: "rgba(113, 129, 152, 1)", marginTop: 4 }}>
                <CreatedTime time={props?.activeOrder?.createdAt} />
              </p>
            </div>

            {/* Line Items */}
            <div style={modalStyles.lineItemsWrap}>
              {props?.activeOrder?.lineItems?.map((el, idx) => (
                <div key={idx} style={modalStyles.lineItem}>
                  <img
                    style={modalStyles.lineItemImg}
                    src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.imageUrl}`}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.style.visibility = "hidden";
                    }}
                  />
                  <div style={modalStyles.lineItemBody}>
                    <h1 style={{ color: "rgba(56, 79, 111, 1)", wordBreak: "break-word" }}>
                      <Truncatedproname text={el.productName} limit={25} fontSize={"16px"} />
                    </h1>
                    <div style={modalStyles.lineItemMeta}>
                      <h1 style={modalStyles.iteam}>{el.unitCount} Items</h1>
                      <h1 style={modalStyles.price}>₹{el.offerPrice?.toFixed(2)}</h1>
                    </div>
                  </div>
                </div>
              ))}

              {/* Grand total */}
              <div style={modalStyles.totalCard}>
                <h1>Grand Total</h1>
                <h1 style={{ whiteSpace: "nowrap" }}>
                  ₹ {props?.activeOrder?.amount?.toFixed(2)}
                </h1>
              </div>
            </div>

            {/* Actions */}
            <div style={modalStyles.actions}>
              <Button
                variant="outlined"
                disabled={isDisabled}
                onClick={(e) => props.CancleOrderset(e, props?.activeOrder?.orderId)}
                sx={{
                  flex: 1,
                  minHeight: "48px",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 500,
                  color: "#404237",
                  border: "1px solid rgba(113, 129, 152, 0.38)",
                }}
              >
                Cancel Order
              </Button>

              <div
                onClick={(e) => {
                  helpFun(e, props?.activeOrder?.orderId);
                }}
                style={modalStyles.helpBtn}
              >
                Help & Support
              </div>
            </div>
          </div>

          {status == "true" && <SwipeToVend fetchCode={fetchCode} />}
        </div>
      ) : (
        <div style={{ marginTop: "50%", textAlign: "center" }}>
          <h1>Something Went Wrong</h1>
        </div>
      )}
    </>
  );
}

export default ActiveOrder;
